import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// @mui material components
import { Grid, Card, Tab, Tabs } from '@mui/material';

import FundingSourceTable from 'components/FundingSourceTable';
import DeactivatedUsersTable from 'components/DeactivatedUsersTable';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import NonUSUsers from '../UserManagement/components/NonUSUsers';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const FundingSources = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState('Removals');

    const handleTabSelect = (tabKey) => {
        switch (tabKey) {
            case 'Removals':
                navigate(
                    {
                        hash: 'Removals',
                    },
                    { replace: true }
                );
                setValue(tabKey);
                break;

            case 'Deactivated':
                navigate(
                    {
                        hash: 'Deactivated',
                    },
                    { replace: true }
                );
                setValue(tabKey);
                break;

            default:
                navigate(
                    {
                        hash: 'Removals',
                    },
                    { replace: true }
                );
                setValue('Removals');
                break;
        }
    };

    const handleChange = (_, newValue) => {
        handleTabSelect(newValue);
    };

    useEffect(() => {
        if (location.hash === '') {
            navigate(
                {
                    hash: 'Removals',
                },
                { replace: true }
            );
        } else {
            handleTabSelect(location.hash?.replace('#', ''));
        }
    }, [location.hash]);

    return (
        <>
            <MDBox pt={1} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                >
                                    <Tab
                                        label="Removals"
                                        value={'Removals'}
                                        id="removals"
                                        {...a11yProps(0)}
                                    />
                                    <Tab
                                        label="Deactivated Users"
                                        value={'Deactivated'}
                                        id="deactivated-users"
                                        {...a11yProps(1)}
                                    />
                                </Tabs>
                            </MDBox>

                            <TabPanel value={value} index={'Removals'}>
                                <FundingSourceTable />
                            </TabPanel>
                            <TabPanel value={value} index={'Deactivated'}>
                                <DeactivatedUsersTable />
                            </TabPanel>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </>
    );
};

export default FundingSources;

